export default "__VITE_ASSET__53319c71__"